<template>
  <div>
    <sButton
      v-if="can_check_prequalification"
      @click="openCheckPrequalification">
      {{ $t('Tenders.ConfirmSelection') }}
    </sButton>
    <CompleteRetraining
      v-else
      :tender="tender"
      :validate="validate"/>
  </div>
</template>
<script>
import CompleteRetraining from 'components/tenders/dialogs/CompleteRetraining.vue'

export default {
  name: 'prequalificationBtns',
  props: {
    tender: Object
  },
  computed: {
    can_check_prequalification() {
      return this.tender?.biddingType?.isFrameFirstStage
    },
    disable() {
      let ret = this.tender.bids.some(bid => {
        return bid.bidDetails.filter(det => det.bidStatus == 'ACTIVE').some(det => {
          return det.prequalification?.status == 'PENDING'
        })
      })
      return ret
    },
    error_text() {

      if ( this.can_check_prequalification ) {
        return this.$t('Tenders.ToCompleteFirstStageOfFramework')
      }
      return this.$t('Tenders.WillBeAblePublishAuction')
    }
  },
  methods: {
    openCheckPrequalification() {
      this.validate()
      this.$store.commit('setTender' , this.tender)
      this.$router.push({name: 'checkPreQualification', params: {tenderId: this.tender.tenderId, org: this.$route.params.org}})
    },
    validate() {
      if ( this.disable ) {
        this.$emit('showBid')
        this.$notice.warning({
          title: this.$t('Tenders.NecessaryToQualifyAllOffers'),
          message: this.error_text,
          showClose: true,
          progress: true,
          duration: 20
        })
        throw this.error_text
      }
    }
  },
  components: {
    CompleteRetraining
  }
}
</script>
